




















































































































































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop, Watch } from 'vue-property-decorator';
import {
  BoxIcon,
  CalendarIcon,
  CheckIcon,
  CheckSquareIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  FilterIcon,
  SearchIcon,
  UserIcon,
  XIcon,
} from 'vue-feather-icons';
import { DateFilter } from 'admiral-core';
import Weekday from 'dayjs/plugin/weekday';
import 'dayjs/locale/de';
import dayjs from 'dayjs';
import Multiselect from 'vue-multiselect';
import { FilterMixin } from '@/mixins/FilterMixin';
import { mixins } from 'vue-class-component';

dayjs.extend(Weekday);
dayjs.locale('de');

@Component({
  name: 'date-filter',
  components: {
    CalendarIcon,
    Multiselect,
    UserIcon,
    BoxIcon,
    SearchIcon,
    XIcon,
    FilterIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    CheckSquareIcon,
    CheckIcon,
  },
})
export default class DateFilterComponent extends mixins(FilterMixin) {
  @Prop({ type: Number })
  selected!: DateFilter;
  @Prop({ type: Number })
  from!: number;
  @Prop({ type: Number })
  to!: number;

  @Prop({ type: String, default: () => '' })
  title!: string;

  @Prop({ type: String, default: () => '' })
  clazz!: string;

  range = {
    start: new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000),
    end: new Date(),
  };
  masks = {
    input: 'DD.MM.YYYY',
  };

  @Watch('selected')
  onChangeSelected() {
    if (this.selected === DateFilter.CUSTOM) {
      if (this.from) {
        this.range.start = new Date(this.from);
      }
      if (this.to) {
        this.range.end = new Date(this.to);
      }
    }
  }

  async mounted() {
    // try {
    //   const filter: LeadFilter = await this.$store.getters['PreferencesModule/getLeadFilter'];
    //
    //   if (filter.from) {
    //     this.range.start = new Date(filter.from);
    //     // @ts-ignore
    //     this.range.end = new Date(filter.to);
    //   }
    // } catch (e) {
    //   // @ts-ignore
    //   this.$toastr.e('Beim Abrufen der Produkte und Mitarbeiter ist etwas schiefgelaufen.');
    // }
  }

  @Watch('dateFilter')
  private onSelectedDateChange() {
    //
  }

  @Watch('range')
  private onRangeChanges() {
    this.$emit('update', {
      dateFilter: DateFilter.CUSTOM,
      from: this.range.start.setHours(0, 0, 0, 0),
      to: this.range.end.setHours(0, 0, 0, 0),
    });
  }

  get isCustomDateFilter() {
    return this.selected === DateFilter.CUSTOM;
  }

  changed(val: DateFilter) {
    this.$emit('update', { dateFilter: val });
  }

  get isDefault() {
    return this.selected === DateFilter.ALL;
  }

  reset() {
    this.$emit('update', { dateFilter: DateFilter.ALL });
  }
}
